"use strict";
import('./bootstrap');
window.addEventListener('auth:login', () => {
    console.log('User logged in, navigating to home...');
    window.location.href = '/';
});
